module.exports = __webpack_public_path__ + "img/MikeVarney.977a27d9.png";